import React, {
  useState,
  useEffect,
  useContext,
  Fragment,
  useCallback,
} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import MeetingData from 'components/brandActivation/viewDetails/meetingData/meetingData';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { Button, Table } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DivLayout from 'components/sales/divLayout/divLayout';
import moment from 'moment';

const CampDetails = ({
  getMeetingById,
  meetingById,
  cancelMeeting,
  completeMeeting,
  updateCampStatus,
  match,
  history,
}) => {
  const [details, setDetails] = useState(null);
  const [poc, setPoc] = useState([]);
  // const [othersEmail, setOthersEmail] = useState([]);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [isCompleteModal, setIsCompleteModal] = useState(false);
  const [statusCode, setStatusCode] = useState(null);

  const getMeeting = useCallback(async () => {
    if (match?.params?.id) {
      setIsLoading(true);
      await getMeetingById(match?.params?.id);
      setIsLoading(false);
    }
  }, [getMeetingById, match?.params?.id]);

  useEffect(() => {
    getMeeting();
  }, [getMeeting]);

  useEffect(() => {
    if (meetingById) {
      setDetails(meetingById);
    }
    if (meetingById?.attendees) {
      setPoc(meetingById.attendees);
    }
    // if (meetingById?.others_email?.length > 0) {
    //   setOthersEmail(meetingById.others_email)
    // }
  }, [meetingById]);

  const handleModalHide = () => setIsModal(false);

  const handleCancelModalHide = () => {
    setIsCancelModal(false);
    history.goBack();
  };

  // const handleCancel = async () => {
  //   (async () => {
  //     setIsLoading(true);
  //     const res = await cancelMeeting(match?.params?.id);
  //     setIsLoading(false);
  //     if (res === true) {
  //       setIsCancelModal(true);
  //     }
  //   })();
  // };

  const handleCompleteModalHide = () => {
    setIsCompleteModal(false);
    history.goBack();
  };

  // const handleComplete = async () => {
  //   (async () => {
  //     setIsLoading(true);
  //     const res = await completeMeeting(match?.params?.id);
  //     setIsLoading(false);
  //     if (res) {
  //       setIsCompleteModal(true);
  //     }
  //   })();
  // };

  const handleStatusChange = (e) => {
    updateCampStatus({
      camp_id: match?.params?.id,
      status: statusCode,
    });
    setStatusCode(null);
    setIsStatusModal(false);
    // setIsCompleteModal(true);
    getMeeting();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        {details !== null && details?.camp?.status === 1 && (
          <Button
            className=" btn btn-transparent"
            onClick={() => setIsStatusModal(true)}
          >
            {localization.changeStatus}
          </Button>
        )}
        {details !== null && details?.camp?.mom_send_status !== null && (
          <Link
            to={
              details?.camp?.mom_send_status === 0
                ? `${baseUrl}/brand-activation/conduct-camp/create-minutes-of-meeting/${details?.camp?.site_id}/${match?.params?.id}`
                : `${baseUrl}/brand-activation/conduct-camp/view-minutes-of-meeting/${match?.params?.id}`
            }
            className="btn btn-primary"
          >
            {details?.camp?.mom_send_status === 0
              ? localization.createMom
              : localization.viewMom}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        )}
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.scheduleCampMeeting}
      Buttons={
        details !== null &&
        details?.camp?.mom_send_status === 0 &&
        (details.status === 'Cancelled' || details.status === 'Completed')
          ? null
          : headerBtns
      }
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp/${details?.camp?.site_id}/${match?.params?.id}`}
    >
      {details && details.camp && Object.keys(details?.camp).length !== 0 ? (
        <div className="panel-card">
          <div className="panel-heading">{localization.meetingDetails}</div>
          <div className="panel-body">
            <div className="details-listing">
              <DivLayout
                heading={localization.raisedTo}
                data={
                  details?.camp?.attendees
                    ? details?.camp?.attendees.join(', ')
                    : ''
                }
              />
              <DivLayout
                heading={localization.scheduledDate}
                data={
                  details?.camp?.scheduled_date
                    ? details?.camp?.scheduled_date
                    : localization.na
                }
              />
              <DivLayout
                heading={localization.scheduledTime}
                data={
                  details?.camp?.scheduled_time
                    ? details?.camp?.scheduled_time
                    : localization.na
                }
              />
              <DivLayout
                heading={localization.status}
                data={
                  details?.camp?.statusName
                    ? details?.camp?.statusName
                    : localization.na
                }
              />

              <DivLayout
                heading={localization.type}
                data={
                  details?.camp?.type ? details?.camp?.type : localization.na
                }
              />
              <DivLayout
                heading={localization.typeOfMeeting}
                data={
                  details?.camp?.camp_type
                    ? details?.camp?.camp_type
                    : localization.na
                }
              />
              {details?.camp_type !== 'Free' && (
                <Fragment>
                  <DivLayout
                    heading={localization.amount}
                    data={
                      details?.camp?.camp_amount
                        ? details?.camp?.camp_amount
                        : localization.na
                    }
                  />

                  <DivLayout
                    heading={localization.utrNumber}
                    data={
                      details?.camp?.utr_number
                        ? details?.camp?.utr_number
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.subject}
                    data={
                      details?.camp?.subject
                        ? details?.camp?.subject
                        : localization.na
                    }
                  />
                  <DivLayout
                    heading={localization.summary}
                    data={
                      details?.camp?.body
                        ? details?.camp?.body
                        : localization.na
                    }
                    fullWidth
                    parentClass={'p-0'}
                    spanClass={'full-width'}
                  />
                  {details && details?.camp?.cheque_attachment ? (
                    <DocumentView
                      title={localization.chequeAttachment}
                      attachment={details?.camp?.cheque_attachment}
                    />
                  ) : null}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      ) : null}
      {details &&
        details.post_camp &&
        Object.keys(details?.post_camp).length !== 0 && (
          <div className="panel-card">
            <div className="panel-heading">{localization.postCampDetails}</div>
            <div className="panel-body">
              <div className="details-list">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Designation</th>
                      <th>Added On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details &&
                      details.post_camp &&
                      details?.post_camp.map((val) => {
                        return (
                          <tr>
                            <td>{val.name}</td>
                            <td>{val.designation}</td>
                            <td>
                              {moment(val.created_at).format('DD-MM-YYYY')}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        )}

      {details &&
      details.checklist &&
      Object.keys(details?.checklist).length !== 0 ? (
        <div className="panel-card">
          <div className="panel-heading">{localization.preCampDetails}</div>
          <div className="panel-body">
            <div className="form-group">
              <div className="details-listing faq-listing">
                {details.checklist.questions.map((item, index1) => {
                  return (
                    <div className="details-list question-input" key={index1}>
                      <label className="data-title">{item.questions}</label>
                      {item.answers.length &&
                        item.answers.map((ele, ind) => {
                          return item.label === 'Photo' ? (
                            <DocumentView
                              title={ele.label}
                              attachment={ele.answer}
                            />
                          ) : (
                            <div className="sub-question" key={ind}>
                              <label className="label">{ele.label}</label>
                              <label className="label">{ele.answer}</label>
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {/* {details !== null &&
      (details.status === "Cancelled" ||
        details.status === "Completed") ? null : (
        <div className="form-group btn-group d-xs-flexflow-wrap pad-0">
          <Button className="btn btn-transparent" onClick={handleCancel}>
            {localization.cancelMeeting}
          </Button>

          <Button className="btn btn-transparent" onClick={handleComplete}>
            {localization.markComplete}
          </Button>

          <Link
            to={`${baseUrl}/brand-activation/reschedule-a-meeting/${details?.site_id}/${match?.params?.id}`}
            className="btn btn-primary"
          >
            {localization.rescheduleMeeting}
          </Link>
        </div>
      )} */}
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingSuccess}</h5>
          <Link
            to={`${baseUrl}/brand-activation/conduct-camp/camp/${details?.camp?.site_id}/${match?.params?.id}`}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      {/* Cancel Meeting PopUp */}
      <ModalPop
        title={localization.conf}
        show={isCancelModal}
        handleModalHide={handleCancelModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingCancelSuccess}</h5>
          <Button
            onClick={handleCancelModalHide}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
      {/* Cancel Meeting PopUp */}
      <ModalPop
        title={localization.conf}
        show={isCompleteModal}
        handleModalHide={handleCompleteModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingMarkedCompleted}</h5>
          <Button
            onClick={handleCompleteModalHide}
            className="btn btn-primary mb-4"
          >
            {localization.goToMeetingList}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.changeStatus}
        show={isStatusModal}
        handleModalHide={() => setIsStatusModal(false)}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5>{localization.pleaseConfirm}</h5>
          <DropDownInput
            label={localization.selectStatus}
            required
            isStarRequired={true}
            data={[
              { id: 3, name: 'Complete' },
              { id: 2, name: 'Reject' },
            ]}
            errorMsg={localization.isRequired}
            getIdValue={(val) => {
              if (val.id) {
                setStatusCode(val.id);
              }
            }}
          />

          <Button
            className="btn btn-primary mb-4"
            onClick={() => handleStatusChange()}
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default CampDetails;
